import { render } from "./HomeDashboard.vue?vue&type=template&id=551351e4&lang=true"
import script from "./HomeDashboard.vue?vue&type=script&lang=ts"
export * from "./HomeDashboard.vue?vue&type=script&lang=ts"
script.render = render

export default script